import { HttpClient, HttpParams, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";

import { GlobalProvider } from "../global/global";
import { AlertController, Platform, ToastController } from "ionic-angular";

@Injectable()
export class ConectorProvider {
  parametros: any;

  headers: any;

  constructor(
    public http: HttpClient,
    public global: GlobalProvider,
    private alertCtrl: AlertController,
    private platform: Platform,
    public toastController: ToastController
  ) {
    this.headers = new HttpHeaders().set("Content-Type", "application/json");
  }

  getConfiguracion() {
    let url = this.global.URLBASEJSON + "configuracion";
    return this.http.post(url, this.headers);
  }

  getVersion() {
    let url = this.global.URLBASEJSON + "configuracion";

    fetch(url, {
      method: "POST", // or 'PUT'
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .catch((error) => console.error("Error:", error))
      .then((response) => {
        this.comprobarVersion(response["version_pwa"]);
      });
  }

  comprobarVersion(version) {
    let version_servidor = version;
    let version_instalada = this.global.VERSION_INSTALADA;

    console.log("version servidor: ", version_servidor);
    console.log("version instalada: ", version_instalada);
    console.log("configura: ", this.global.CONFIGURA);

    if (version_instalada != version_servidor) {
      console.log("versiones diferentes");
      console.log("comprobando");
      const alert = this.alertCtrl.create({
        title:
          "Existe una nueva versión de la aplicación. Versión instalada " +
          version_instalada +
          ". Nueva versión " +
          version_servidor,
        subTitle: "Es necesario reiniciar.",
        buttons: [
          {
            text: "Reiniciar",
            handler: (value) => {
              caches.keys().then(function (cacheNames) {
                console.log("cacheNames", cacheNames);
                cacheNames
                  .filter(function (cacheName) {})
                  .map(function (cacheName) {
                    console.log("Delete cache", cacheName);
                    return caches.delete(cacheName);
                  });
              });

              window.location.reload();
              this.platform.exitApp();
            },
          },
          {
            text: "Cancelar",
            role: "cancel",
            handler: (data) => {
              console.log("Cancel clicked");
            },
          },
        ],
      });

      alert.present();
    }
  }

  getcuadrantepropio(fecha) {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "cuadrante-propio";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);
    if (fecha) {
      params = params.append("fecha", fecha);
    }

    return this.http.post(url, params, this.headers);
  }

  getcuadrantecentro(fecha, idcentro) {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "cuadrante-centro";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    if (idcentro) {
      params = params.append("idcentro", idcentro);
    } else {
      params = params.append("idcentro", "20"); //central
    }
    if (fecha) {
      params = params.append("fecha", fecha);
    }

    return this.http.post(url, params, this.headers);
  }

  getLicencias() {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "licencias";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  getSolicitudes() {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "solicitudes";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  getComunicaciones() {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "mensajes";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  getMensajes() {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "notificaciones";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  GuardarSolicitud(tipo, fdesde, fhasta, descripcion) {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "enviar-solicitud";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    params = params.append("tipo", tipo);

    let fechaTMP = fdesde.split("-");
    let fechaNueva = fechaTMP[2] + "-" + fechaTMP[1] + "-" + fechaTMP[0];
    params = params.append("fdesde", fechaNueva);

    fechaTMP = fhasta.split("-");
    fechaNueva = fechaTMP[2] + "-" + fechaTMP[1] + "-" + fechaTMP[0];
    params = params.append("fhasta", fechaNueva);
    params = params.append("descripcion", descripcion);

    return this.http.post(url, params, this.headers);
  }

  CambiarClave(clave) {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "cambiar-clave";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    params = params.append("clave", clave);

    return this.http.post(url, params, this.headers);
  }

  clearBagde() {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "clear-badge";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  registraractividad(log) {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "registrar-actividad";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    params = params.append("actividad", log);

    return this.http.post(url, params, this.headers);
  }

  presentToast(message, duration = 2000, position = "bottom") {
    const toast = this.toastController.create({
      message,
      duration,
      position,
    });
    toast.present();
  }

  responderSolicitud(idSolicitud, descripcion) {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "solicitud/responder";

    let params = new HttpParams();

    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);
    params = params.append("idsolicitud", idSolicitud);
    params = params.append("descripcion", descripcion);

    console.log("parametros", params);

    return this.http.post(url, params, this.headers);
  }

  responderMensaje(idMensaje, descripcion) {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "mensaje/responder";

    let params = new HttpParams();

    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);
    params = params.append("idmensaje", idMensaje);
    params = params.append("descripcion", descripcion);

    console.log("parametros", params);

    return this.http.post(url, params, this.headers);
  }

  enviarMensaje(descripcion) {
    this.parametros = this.global.UKT;

    let url = this.global.URLBASEJSON + "enviar-mensaje";

    let params = new HttpParams();

    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);
    params = params.append("descripcion", descripcion);

    console.log("parametros", params);

    return this.http.post(url, params, this.headers);
  }

  getVacaciones() {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "vacaciones";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  getDocumentos() {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "documentos";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  getHoras() {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "horas";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }

  getOtros() {
    this.parametros = this.global.UKT;
    let url = this.global.URLBASEJSON + "otros";

    let params = new HttpParams();
    params = params.append("u", this.parametros.u);
    params = params.append("k", this.parametros.k);
    params = params.append("t", this.parametros.t);

    return this.http.post(url, params, this.headers);
  }
}



// WEBPACK FOOTER //
// ./src/providers/conector/conector.ts